import api, { downloadFile } from './client';

/**
 * Déclenche le téléchargement du fichier Excel pour un tenant.
 * @param {string} tenantId
 * @param {string} [domain]  - "people" pour le périmètre Input People, sinon tout.
 */
export async function exportTenant(tenantId, domain, year, template, blank) {
  const params = new URLSearchParams();
  if (template)    params.set('template', template);
  else if (domain) params.set('domain', domain);
  if (year)        params.set('year', year);
  if (blank)       params.set('blank', '1');
  const qs = params.toString() ? `?${params}` : '';
  await downloadFile(
    `/tenants/${tenantId}/export${qs}`,
    `palestre_${template || domain || 'export'}${year ? '_' + year : ''}.xlsx`,
  );
}

/**
 * Déclenche le téléchargement de la sauvegarde complète (JSON) du tenant :
 * toutes les tables, fidélité totale, à conserver avant une suppression.
 * @param {string} tenantId
 * @param {string} [tenantName] - pour nommer le fichier téléchargé.
 */
export async function dumpTenant(tenantId, tenantName) {
  const safe = (tenantName || tenantId).replace(/[^a-z0-9]+/gi, '_').toLowerCase();
  await downloadFile(`/tenants/${tenantId}/dump`, `palestre_sauvegarde_${safe}.json`);
}

/**
 * Importe un fichier Excel et retourne les stats.
 * @param {string} tenantId
 * @param {File}   file              - fichier .xlsx sélectionné par l'utilisateur
 * @param {"ignore"|"overwrite"} conflictStrategy
 */
export async function importTenant(tenantId, file, conflictStrategy = 'ignore', year) {
  const form = new FormData();
  form.append('file', file);
  form.append('conflict_strategy', conflictStrategy);
  if (year) form.append('year', year);

  try {
    // Content-Type laissé au navigateur : il ajoute la frontière multipart.
    const res = await api.post(`/tenants/${tenantId}/import`, form, {
      headers: { 'Content-Type': undefined },
    });
    return res.data.data; // { created, skipped, overwritten, errors }
  } catch (e) {
    const body = e.response?.data;
    throw new Error(body?.detail || body?.error || e.message);
  }
}
